import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { useGlobalContext } from "../Config";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import Loader from "../components/Loader.js";
import { Toast } from 'primereact/toast';

const MantenedorTipoProducto = () => {
  const toast = useRef(null);
  const idUsuario = sessionStorage.getItem("usuario_id");
  const { baseUrl, headerText } = useGlobalContext();
  const [tipoProductos, setTipoProductos] = useState([]);
  const [selectedTipoProducto, setSelectedTipoProducto] = useState(null);
  const [descripcion, setDescripcion] = useState("");
  const [unidad, setUnidad] = useState("");
  const [tarifa, setTarifa] = useState(null);
  const [displayCreateDialog, setDisplayCreateDialog] = useState(false);
  const [displayEditDialog, setDisplayEditDialog] = useState(false);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [loading, setLoading] = useState(false);

  // OBTENER EMPRESAS
  const [empresa, setEmpresas] = useState(null);
  const [listaEmpresas, setListaEmpresas] = useState([]);
  const obtenerEmpresas = async () => {
    try {
      const response = await fetch(`${baseUrl}/getAllEmpresas`);
      const data = await response.json();
      setListaEmpresas(data.empresas);
      if (data.empresas && data.empresas.length > 0) {
        setEmpresas(data.empresas[0].id);
      }
    } catch (error) {
      console.error("Error al obtener las empresas:", error);
    }
  };
  const nombreEmpresa = listaEmpresas.find(item => item.id === empresa)?.nombre;


  const fetchTipoProductos = async () => {
    if (!empresa) {
      console.error("No hay empresa seleccionada");
      alert("Seleccione una empresa");
      return;
    }

    if (!nombreEmpresa) {
      console.error("No se pudo obtener el nombre de la empresa");
      alert("Error al obtener el nombre de la empresa");
      return;
    }

    try {
      setLoading(true);
      console.log("Obteniendo tipos de producto para:", {
        empresaId: empresa,
        nombreEmpresa: nombreEmpresa
      });
      
      const response = await fetch(
        `${baseUrl}getTiposProductoByEmpresa?empresa=${encodeURIComponent(nombreEmpresa)}`
      );

      if (!response.ok) {
        throw new Error(`Error en la respuesta: ${response.status}`);
      }

      const data = await response.json();
      
      console.log("Respuesta del servidor:", data);
      
      if (!data.tiposProductos || !Array.isArray(data.tiposProductos)) {
        console.error("Error: Formato de respuesta inválido", data);
        setLoading(false);
        return;
      }
      
      setTipoProductos(data.tiposProductos);
      console.log("Tipos de producto actualizados:", data.tiposProductos);
      setLoading(false);
    } catch (error) {
      console.error("Error al obtener tipos de producto:", error);
      alert("Error al cargar los tipos de producto");
      setLoading(false);
    }
  };

  const [unidades, setUnidades] = useState([
    { label: "Metro cuadrado (m²)", value: "m**2" },
    // { label: "Metro cúbico (m³)", value: "m**3" },
  ]);

  useEffect(() => {
    obtenerEmpresas();
  }, [baseUrl]);

  useEffect(() => {
    if (empresa) {
      fetchTipoProductos();
    }
  }, [empresa, baseUrl]);


  const validateInputs = () => {
    if (!descripcion || descripcion.trim() === "") {
      alert("La descripción es obligatoria");
      return false;
    }
    const invalidChars = /[|°!"#$%&/()='?¿¡{}]/;
    if (invalidChars.test(descripcion)) {
      alert("La descripción no debe contener caracteres especiales");
      return false;
    }
    if (!unidad || unidad.trim() === "") {
      alert("La unidad es obligatoria");
      return false;
    }
    if (tarifa === null || tarifa < 0) {
      alert("La tarifa debe ser un número positivo");
      return false;
    }
    if (!empresa) {
      alert("Debe seleccionar una empresa");
      return false;
    }
    return true;
  };


  const handleCreateTipoProducto = async () => {
    if (!validateInputs()) return;
    try {
      setLoading(true);

      // Validación: no permitir crear tipos de producto con la misma descripción
      if (!nombreEmpresa) {
        alert("Error: No se ha seleccionado una empresa");
        setLoading(false);
        return;
      }

      // Normalización de datos
      const descNormalized = (descripcion || "")
        .trim()
        .normalize("NFC")
        .toLocaleUpperCase("es-ES");

      // Verificar si hay tipos de producto cargados
      if (!Array.isArray(tipoProductos)) {
        console.error("Error: tipoProductos no es un array");
        setLoading(false);
        return;
      }

      // Buscar duplicados solo por descripción
      let encontroDuplicado = false;
      tipoProductos.forEach((tipo, index) => {
        const tipoDesc = tipo.descripcion
          ? tipo.descripcion.trim().normalize("NFC").toLocaleUpperCase("es-ES")
          : '';
        
        console.log(`Comparando item ${index}:`, {
          descripcionExistente: tipoDesc,
          coincideDescripcion: tipoDesc === descNormalized
        });

        if (tipoDesc === descNormalized) {
          encontroDuplicado = true;
        }
      });

      if (encontroDuplicado) {
        alert("Ya existe un tipo de producto con esa descripción.");
        setLoading(false);
        return;
      }

      await createTipoProductoAPI(descNormalized, unidad, nombreEmpresa, tarifa);
      toast.current.show({ severity: 'success', summary: 'Success', detail: 'Tipo Producto creado exitosamente' });
      setDisplayCreateDialog(false);
      await fetchTipoProductos(); 

    } catch (error) {
      toast.current.show({ severity: 'error', summary: 'Error', detail: 'Error al crear el Tipo Producto' });
      console.error("Error detallado al crear el Tipo Producto:", error);
    }finally{
      setLoading(false);
    }
  };

  const createTipoProductoAPI = async (
    descripcion,
    unidad,
    empresa,
    tarifa
  ) => {
    const queryParams = new URLSearchParams({
      descripcion,
      unidad,
      empresa,
      idUsuario,
      tarifa,
    });
    const response = await fetch(
      `${baseUrl}createTipoProducto?${queryParams.toString()}`,
      {
        method: "POST",
        headers: headerText,
      }
    );

    if (!response.ok) {
      throw new Error("Error creating TipoProducto");
    }
  };


  const handleUpdateTipoProducto = async () => {
    if (!validateInputs()) return;
    try {
      const updatedTipoProducto = {
        ...selectedTipoProducto,
        descripcion,
        unidad,
        tarifa,
      };
      setLoading(true);
      await updateTipoProductoAPI(updatedTipoProducto);
      toast.current.show({ severity: 'success', summary: 'Success', detail: 'Tipo Producto actualizado exitosamente' });
      setDisplayEditDialog(false);
      fetchTipoProductos();
      setLoading(false);
    } catch (error) {
      toast.current.show({ severity: 'error', summary: 'Error', detail: 'Error al actualizar el Tipo Producto' });
      console.error("Error updating TipoProducto:", error);
    }
  };

  const updateTipoProductoAPI = async (tipoProducto) => {
    const response = await fetch(`${baseUrl}updateTipoProducto`, {
      method: "PUT",
      headers: headerText,
      body: JSON.stringify(tipoProducto),
    });

    if (!response.ok) {
      throw new Error("Error updating TipoProducto");
    }
  };

  // Deactivate a TipoProducto (soft delete)
  const handleDeleteTipoProducto = (id) => {
    confirmDialog({
      message: "¿Estás seguro de que deseas desactivar este Tipo Producto?",
      header: "Confirmar Desactivación",
      icon: "pi pi-exclamation-triangle",
      accept: async () => {
        await deleteTipoProductoAPI(id);
        fetchTipoProductos();
      },
    });
  };

  const deleteTipoProductoAPI = async (id) => {
    const response = await fetch(`${baseUrl}deleteTipoProducto?id=${id}`, {
      method: "DELETE",
    });

    if (!response.ok) {
      alert("Error al desactivar el Tipo Producto");
      throw new Error("Error desactivating TipoProducto");
    }
  };

  // Activate a TipoProducto
  const handleActivateTipoProducto = async (id) => {
    confirmDialog({
      message: "¿Estás seguro de que deseas activar este Tipo Producto?",
      header: "Confirmar Activación",
      icon: "pi pi-exclamation-triangle",
      accept: async () => {
        await activateTipoProductoAPI(id);
        fetchTipoProductos();
      },
    });
  };

  const activateTipoProductoAPI = async (id) => {
    const response = await fetch(`${baseUrl}activateTipoProducto?id=${id}`, {
      method: "PUT",
    });

    if (!response.ok) {
      alert("Error al activar el Tipo Producto");
      throw new Error("Error activating TipoProducto");
    }
  };

  // Header for the table
  const renderHeader = () => (
    <div className="flex justify-content-between">
      <span className="p-input-icon-left" style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
        <i className="pi pi-search" />
        <InputText
          value={globalFilterValue ? globalFilterValue.toUpperCase() : ""}
          onChange={(e) =>
            setGlobalFilterValue(e.target.value.toUpperCase())
          }
          placeholder="Buscar por Descripción"
        />
      </span>
      <span className="p-input-icon-left ml-2" style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
        {tipoProductos?.length} tipos
      </span>
    </div>
  );

  return (
    <div className="grid">
      <Toast ref={toast} />
      <div className="col-12">
        <div className="card">
          <h4>Gestión de Tipos Productos</h4>
          <div className="p-field">
            <label htmlFor="empresa">Seleccione Empresa: </label>
            <Dropdown
              id="empresa"
              value={empresa}
              onChange={(e) => {
                console.log("Empresa seleccionada:", e.value);
                setEmpresas(e.value);
                setDescripcion("");
                setUnidad("");
                setTarifa(null);
              }}
              options={listaEmpresas}
              optionLabel="nombre"
              optionValue="id"
              placeholder="Seleccione Empresa"
              className="p-inputtext-sm"
              style={{ borderRadius: "4px" }}
            />
        </div>
      </div>
        {empresa && (
          <>            
            {loading ? (
              <>
                <Loader />
              </>
            ) : (
              <>
                <div className="card">
                  <Button
                    label="Crear Tipo Producto"
                    icon="pi pi-plus"
                    onClick={() => {
                      setDescripcion("");
                      setUnidad("");
                      setTarifa(null);
                      setDisplayCreateDialog(true);
                    }}
                    className="p-button p-component p-button-rounded p-button-primary mb-3"
                    raised
                  />
                  <DataTable
                    value={tipoProductos}
                    loading={loading}
                    header={renderHeader()}
                    globalFilter={globalFilterValue}
                    className="p-datatable-gridlines mt-3"
                    showGridlines
                    paginator
                    rows={10}
                    rowsPerPageOptions={[10, 20, 50, 100]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} tipos de producto"
                    dataKey="id"
                    emptyMessage="No se encontraron tipos de producto."
                    stripedRows="true"
                    id="tipoProductoTable"
                    globalFilterFields={["descripcion", "unidad"]}
                    tableStyle={{
                      tableLayout: "fixed",
                      width: "100%",
                      minWidth: "1000px",
                    }}
                    scrollable
                    scrollHeight="57vh"
                  >
                    <Column field="descripcion" header="Descripción" sortable />

                    <Column
                      field="unidad"
                      header="Unidad"
                      sortable
                      body={(rowData) => {
                        if (rowData.unidad === "m**2") return "m²";
                        if (rowData.unidad === "m**3") return "m³";
                        return rowData.unidad;
                      }}
                    />

                    <Column
                      field="tarifa"
                      header="Tarifa"
                      sortable
                      sortField="tarifa.tarifa_base"
                      dataType="numeric"
                      body={(rowData) => {
                        if (rowData.tarifa && rowData.tarifa.tarifa_base != null) {
                          return rowData.tarifa.tarifa_base;
                        }
                        return "-";
                      }}
                    />

                    <Column
                      field="empresa"
                      header="Empresa"
                      sortable
                      body={(rowData) => {
                        return rowData.nombre_empresa;
                      }}
                    />

                    <Column
                      field="activo"
                      header="Activo"
                      body={(rowData) => (
                        <>
                          {rowData.activo ? (
                            <Button
                              icon="pi pi-check"
                              className="p-button-rounded p-button-success p-button mr-2 mb-2 mt-2"
                              outlined
                            />
                          ) : (
                            <Button
                              icon="pi pi-times"
                              className="p-button-rounded p-button-danger p-button mr-2 mb-2 mt-2"
                              onClick={() => {}}
                              outlined
                            />
                          )}
                        </>
                      )}
                      sortable
                    />
                    {/* <Column
                      header="Acciones"
                      body={(rowData) => (
                        <>
                          <Button
                            icon="pi pi-pencil"
                            className="p-button-rounded p-button-success mr-2"
                            label="Editar"
                            onClick={() => {
                              setSelectedTipoProducto(rowData);
                              setDescripcion(rowData.descripcion);
                              setUnidad(rowData.unidad);
                              setTarifa(rowData.tarifa); // Assuming you have this data available
                              setActivo(rowData.activo);
                              setDisplayEditDialog(true);
                            }}
                            outlined
                            disabled
                          />
                          {rowData.activo ? (
                            <Button
                              icon="pi pi-trash"
                              className="p-button-rounded p-button-danger"
                              onClick={() => handleDeleteTipoProducto(rowData.id)}
                              label="Desactivar"
                            />
                          ) : (
                            <Button
                              icon="pi pi-check"
                              className="p-button-rounded p-button-info"
                              onClick={() => handleActivateTipoProducto(rowData.id)}
                              label="Activar"
                            />
                          )} 
                        </>
                      )}
                    />*/}
                  </DataTable>

                  <Dialog
                    header="Crear Tipo de Producto"
                    visible={displayCreateDialog}
                    className="p-fluid product-dialog"
                    onHide={() => setDisplayCreateDialog(false)}
                    footer={
                      <div className="p-d-flex p-jc-end p-mt-3">
                        <Button
                          label="Cancelar"
                          icon="pi pi-times"
                          onClick={() => setDisplayCreateDialog(false)}
                          className="p-button p-button-rounded p-button-outlined p-mr-2"
                        />

                        <Button
                          label="Guardar"
                          icon="pi pi-save"
                          onClick={handleCreateTipoProducto}
                          className="p-button-success p-button-rounded"
                          autoFocus
                          disabled={loading || !descripcion || !unidad || !tarifa}
                          raised
                        />
                      </div>
                    }
                  >
                    <div className="p-grid p-formgrid p-fluid">
                      <h6 className="mb-3">
                          Información del Tipo de Producto
                      </h6>

                      <span className="p-float-label mt-2 mb-3">
                        <InputText
                          id="descripcion"
                          value={descripcion}
                          onChange={(e) => setDescripcion(e.target.value.toUpperCase())}
                          className="p-inputtext-lg"
                          placeholder="Ingrese la descripción del tipo de producto"
                          maxLength={255}
                        />
                        <label htmlFor="descripcion"><i className="pi pi-tag"></i> Descripción *</label>
                      </span>

                      <span className="p-float-label mt-2 mb-3">
                        <Dropdown
                          id="unidad"
                          value={unidad}
                          options={unidades}
                          onChange={(e) => setUnidad(e.value)}
                          placeholder="Seleccione una unidad"
                          optionLabel="label"
                          className="p-inputtext-lg"
                        />
                        <label htmlFor="unidad"><i className="pi pi-cog"></i> Unidad *</label>
                      </span>

                      <span className="p-float-label mt-2 mb-3">
                        <InputNumber
                          id="tarifa"
                          value={tarifa}
                          onValueChange={(e) => setTarifa(e.value)} // Handle value change
                          mode="decimal" // Handle decimal numbers
                          minFractionDigits={0} // Set minimum number of decimal digits
                          maxFractionDigits={2} // Set maximum number of decimal digits
                          placeholder="Ingrese la tarifa en UF"
                          className="p-inputtext-lg"
                          locale="es-ES" // Set locale to use comma for decimal
                          inputMode="decimal" // HTML5 input mode for numeric decima
                          min={0.01}
                          max={1000}
                        />
                        <label htmlFor="tarifa"><i className="pi pi-money-bill"></i> Tarifa UF *</label>
                      </span>

                    </div>
                  </Dialog>

                  <Dialog
                    header="Editar Tipo Producto"
                    visible={displayEditDialog}
                    
                    onHide={() => setDisplayEditDialog(false)}
                    className="p-fluid product-dialog"
                    footer={
                      <div className="p-d-flex p-jc-end p-mt-3">
                        <Button
                          label="Cancelar"
                          icon="pi pi-times"
                          onClick={() => setDisplayEditDialog(false)}
                          className="p-button-outlined p-button-rounded p-mr-2"
                        />
                        <Button
                          label="Guardar"
                          icon="pi pi-check"
                          onClick={handleUpdateTipoProducto}
                          className="p-button-success p-button-rounded"
                          autoFocus
                          disabled={loading}
                          raised
                        />
                      </div>
                    }
                  >
                    <div className="p-grid p-formgrid p-fluid">
                
                      <span className="p-float-label mt-2 mb-3">
                        <InputText
                          id="descripcion"
                          value={descripcion}
                          onChange={(e) =>
                            setDescripcion(e.target.value.toUpperCase())
                          }
                          className="p-inputtext-lg"
                          placeholder="Ingrese la descripción del tipo de producto"
                          disabled
                          max={45}
                        />
                        <label htmlFor="descripcion"><i className="pi pi-tag"></i> Descripción</label>
                      </span>
                        
                      <span className="p-float-label mt-2 mb-3">
                        <Dropdown
                          id="unidad"
                          value={unidad}
                          options={unidades}
                          onChange={(e) => setUnidad(e.value)}
                          placeholder="Seleccione una unidad"
                          optionLabel="label"
                          className="p-inputtext-lg"
                          disabled
                        />
                        <label htmlFor="unidad"><i className="pi pi-cog"></i> Unidad</label>
                      </span>
                    </div>
                  </Dialog>
                </div>
              </>
            )}
          </>
        )}

        <ConfirmDialog />
      </div>
    </div>
  );
};

export default MantenedorTipoProducto;
